import axios from 'axios';

export const api = axios.create({
  baseURL: '',
  timeout:10000,  
  });

export const setupAxiosInterceptors = (dispatch) => {
api.interceptors.response.use(
  response => response,
  async error => {
    const config = error.config;
    //Retry logic for network errors or 5xx responses
    if(config?.retryCount === undefined) {
      config.retryCount = 0;
    }
    if (error?.config?.skipInterceptor) {
      throw error;
    }
    if(error?.name === 'CanceledError') {
      return;
    } else {
    const status = error.response?.status;
    console.log(status)
    // switch (status) {
    //   case 400:
    //   case 404:
    //   case 500:
    //   case 503:
    //     dispatch({
    //     type: ActionTypes.STATUS_TOASTMESSAGE,
    //     payload: { open: true, message: "Something went wrong! Please try again.", status: "error" }
    //   });
    //     break;
    //   case 401:
    //     dispatch({
    //     type: ActionTypes.STATUS_TOASTMESSAGE,
    //     payload: { open: true, message: "Unauthorized. Please log in again.", status: "error" }
    //   });
    //     break;
    //   case 403:
    //     dispatch({
    //     type: ActionTypes.STATUS_TOASTMESSAGE,
    //     payload: { open: true, message: 'Forbidden. You do not have access.', status: "error" }
    //   });
    //   break;
    //   default:
    //     dispatch({
    //     type: ActionTypes.STATUS_TOASTMESSAGE,
    //     payload: { open: true, message: 'An unexpected error occurred.', status: "error" }
    //   });
    //     break;
    // }
  }
   throw error;
 }
);
}